import { render } from "./unauthorize.vue?vue&type=template&id=61597425&lang=true"
import script from "./unauthorize.vue?vue&type=script&lang=js"
export * from "./unauthorize.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__